const pl = {
  tools_actions: {
    hotel_info: "Szukam informacji o hotelu...",
    accommodation_info: "Szukam informacji o hotelu...",
    accomodation_info: "Szukam informacji o hotelu...",
    get_destination_info: "Szukam, co warto zobaczyć w okolicy...",
    get_guest_information: "Sprawdzam Państwa rezerwację...",
    book_hotel_service_or_get_availability: "Sprawdzam dostępność usługi...",
    list_accomodations: "Wczytuję obiekty...",
    set_accomodation: "Wczytuję obiekt...",
    list_accommodations: "Wczytuję obiekty...",
    set_accommodation: "Wczytuję obiekt...",
    destination_info: "Szukam, co warto zobaczyć w okolicy...",
    show_map: "Przygotowuję mapę...",
    consult_rules: "Sprawdzam regulamin obiektu...",
    notify_reception: "Powiadamiam recepcję...",
    save_self_declared_stay: "Zapisuję Twój pobyt...",
    generate_quote_for_single_room_longstay_rooms: "Przygotowuję wycenę...",
    generate_quote_for_multiple_rooms_longstay: "Przygotowuję wycenę...",
    hotel_info_iodah:
      "Doskonale, zbieram informacje i zaraz wracam z odpowiedzią...",
    generate_quote_for_rooms: "Przygotowuję wycenę...",
    check_availability: "Sprawdzam dostępność...",
    print_calendar: "Sprawdzam kalendarz...",
    nearby_restaurants: "Szukam restauracji w okolicy...",
    nearby_attractions: "Szukam atrakcji w okolicy...",
    human_handoff: "Łączę z konsultantem...",
    tool_search_offers_by_request: "Szukam najlepszych ofert dla Państwa...",
    tool_search_hotels_by_request: "Szukam najlepszych hoteli dla Państwa...",
  },
  tool_status_sequences: {
    generate_quote_for_rooms: [
      "Sprawdzam dostępność w wybranych terminach…",
      "Porównuję pokoje i ceny…",
      "Przygotowuję wycenę…",
    ],
    generate_quote_for_single_room_longstay_rooms: [
      "Sprawdzam dostępność w wybranych terminach…",
      "Porównuję pokoje i ceny…",
      "Przygotowuję wycenę…",
    ],
    generate_quote_for_multiple_rooms_longstay: [
      "Sprawdzam dostępność w wybranych terminach…",
      "Porównuję pokoje i ceny…",
      "Przygotowuję wycenę…",
    ],
    check_availability: [
      "Sprawdzam kalendarz…",
      "Weryfikuję dostępność…",
      "Jeszcze moment…",
    ],
    hotel_info: [
      "Przeglądam informacje o hotelu…",
      "Zbieram szczegóły…",
      "Przygotowuję odpowiedź…",
    ],
    accommodation_info: [
      "Przeglądam informacje o hotelu…",
      "Zbieram szczegóły…",
      "Przygotowuję odpowiedź…",
    ],
    accomodation_info: [
      "Przeglądam informacje o hotelu…",
      "Zbieram szczegóły…",
      "Przygotowuję odpowiedź…",
    ],
    get_destination_info: [
      "Odkrywam okolicę…",
      "Wybieram najlepsze propozycje…",
      "Już prawie gotowe…",
    ],
    nearby_restaurants: [
      "Szukam restauracji w okolicy…",
      "Wybieram najlepiej dopasowane…",
      "Już prawie gotowe…",
    ],
    nearby_attractions: [
      "Szukam atrakcji w okolicy…",
      "Wybieram to, co najlepsze…",
      "Już prawie gotowe…",
    ],
    get_guest_information: [
      "Odnajduję Państwa rezerwację…",
      "Sprawdzam szczegóły pobytu…",
      "Jeszcze moment…",
    ],
    book_hotel_service_or_get_availability: [
      "Sprawdzam dostępność usługi…",
      "Weryfikuję godziny…",
      "Jeszcze moment…",
    ],
    print_calendar: ["Otwieram kalendarz…", "Sprawdzam terminy…"],
    list_accomodations: ["Wczytuję obiekty…", "Przygotowuję listę…"],
    set_accomodation: ["Otwieram obiekt…", "Pobieram informacje…"],
    list_accommodations: ["Wczytuję obiekty…", "Przygotowuję listę…"],
    set_accommodation: ["Otwieram obiekt…", "Pobieram informacje…"],
    destination_info: [
      "Odkrywam okolicę…",
      "Wybieram najlepsze propozycje…",
      "Już prawie gotowe…",
    ],
    show_map: ["Zaznaczam miejsca na mapie…", "Przygotowuję trasę…"],
    consult_rules: ["Sprawdzam regulamin obiektu…", "Weryfikuję warunki…"],
    notify_reception: ["Powiadamiam recepcję…", "Przekazuję prośbę…"],
    save_self_declared_stay: ["Zapisuję Twój pobyt…", "Łączę rezerwację…"],
    human_handoff: ["Powiadamiam recepcję…", "Przekazuję rozmowę…"],
    tool_search_offers_by_request: [
      "Szukam najlepszych ofert dla Państwa…",
      "Porównuję możliwości…",
      "Już prawie gotowe…",
    ],
    tool_search_hotels_by_request: [
      "Szukam najlepiej dopasowanych hoteli…",
      "Porównuję możliwości…",
      "Już prawie gotowe…",
    ],
  },
  status_thinking: ["Chwileczkę…", "Zastanawiam się…", "Jeszcze moment…"],
  status_generic: ["Już prawie gotowe…", "Jeszcze moment…"],
  tooltip_sentences: [
    "Potrzebna szybka wycena? 😊",
    "Potrzebne informacje o hotelu? 😊",
  ],
  tooltip_sentences_iodah: [
    "Witamy w The First Hotels.",
    "Jak mogę dziś pomóc?",
  ],
  // Variant B of the open-rate experiment: two clickable teaser pills ·
  // a fixed high-intent hook on top, a rotating multi-intent pill below.
  // A click opens the chat and sends the pill as the guest message.
  // Hotels can override these from the backoffice (per locale); these are
  // the defaults when no configuration is present.
  welcome_message_default:
    "Witamy! 👋 Jestem wirtualnym asystentem hotelu. Sprawdzę dostępność i ceny oraz odpowiem na każde pytanie dotyczące pobytu. W czym mogę pomóc?",
  teaser_pill_fixed: "Wycena w 30 sekund ⚡",
  teaser_pills_rotating: [
    "Są wolne pokoje w moim terminie? 📅",
    "Jakie pokoje są dostępne? 🛏️",
    "Jak wygląda śniadanie? 🥐",
  ],
  quote_pills: {
    alone: "Tylko ja",
    alone_message: "Tylko ja, jedna osoba",
    party: "Jest nas {n}",
    party_message: "Jest nas {n} osob",
  },
  replies_in_realtime: "Odpowiedzi w czasie rzeczywistym",
  ai_disclosure: "Jestem asystentem AI obiektu. W każdej chwili można poprosić o kontakt z obsługą.",
  assistant_default_name: "Nazwa asystenta",
  powered_by: "Obsługiwane przez",
  type_a_message: "Napisz wiadomość...",
  speak_with_operator: "Porozmawiaj z konsultantem",
  // "Call us" card in the welcome message (VoiceCallCard).
  voice_call: {
    title: "Zadzwoń do nas",
    subtitle: "Nasz asystent głosowy odbiera od razu",
    badge: "Nowość",
    call: "Zadzwoń",
    copy: "Kopiuj numer",
    copied: "Numer skopiowany",
  },
  voice_panel: {
    status_idle: "Gotowa",
    status_connecting: "Przygotowuję głos...",
    status_listening: "Słucham",
    status_error: "Błąd połączenia",
    status_warming: "Rozgrzewam głos...",
    transcript_empty: "Powiedz coś…",
    end_call: "Zakończ połączenie",
    start_call: "Rozpocznij połączenie głosowe",
    start_mode: "Włącz tryb głosowy",
    stop_mode: "Zakończ tryb głosowy",
  },
  continue_on_whatsapp: "Kontynuuj na WhatsAppie",
  whatsapp_handoff_prefill:
    "Dzień dobry! Rozmawiałam z asystentem na stronie i chciałabym kontynuować tutaj.",
  request_quote: "Poproś o wycenę",
  map_directions: "Otwórz w Mapach",
  handoff_form: {
    title: "Skontaktuj się z nami",
    desc: "Prosimy o pozostawienie danych kontaktowych. Nasz zespół odezwie się jak najszybciej.",
    firstname: "Imię",
    lastname: "Nazwisko",
    email: "E-mail",
    phone: "Telefon",
    phone_hint: "Użyjemy go do kontaktu, także przez WhatsApp.",
    phone_search: "Wyszukaj kraj",
    submit: "Wyślij zapytanie",
    success:
      "Dziękujemy! Otrzymaliśmy dane kontaktowe i odezwiemy się jak najszybciej. 😊",
    handoff_email_success:
      "Odpowiemy e-mailem na {email}. Możesz zamknąć tę stronę.",
    submit_error: "Coś poszło nie tak. Spróbuj ponownie za chwilę.",
    firstname_error: "Prosimy podać imię.",
    lastname_error: "Prosimy podać nazwisko.",
    email_error: "Prosimy podać poprawny adres e-mail.",
    phone_error: "Prosimy podać poprawny numer telefonu.",
    close_aria_label: "Zamknij",
  },
  error_generic: "Coś poszło nie tak. Spróbuj ponownie później.",
  delete_chat_aria_label: "Usuń rozmowę",
  close_aria_label: "Zamknij rozmowę",
  send_aria_label: "Wyślij wiadomość",
  chat_widget_aria_label: "Widget czatu",
  previous_aria_label: "Poprzednie",
  next_aria_label: "Następne",
  attachment_alt: "Załącznik",
  assistant_icon_alt: "Ikona asystenta",
  bot_avatar_alt: "Awatar asystenta",
  video_label: "Wideo {n}",
  open_content: "Otwórz treści",
  book_now: "Zarezerwuj teraz",
  // Inline link chips in a message (CustomLinkRenderer): shown next to the
  // address/number the assistant wrote, and used as the accessible label.
  send_email: "Wyślij e-mail",
  call_now: "Zadzwoń",
  whatsapp_chat: "Napisz na WhatsAppie",
  open_link: "Otwórz link",
  discover_hotel: "Poznaj hotel",
  discover_offer: "Poznaj ofertę",
  quick_quote: "Poproś o szybką wycenę",
  view_hotel_photos: "Zobacz zdjęcia hotelu",
  view_photos: "Zobacz zdjęcia",
  hotel_gallery: "Hotel",
  restaurant_gallery: "Restauracja",
  animation_gallery: "Animacje",
  rooms_gallery: "Pokoje",
  look_hotel_galleries: "Zobacz galerie hotelu:",
  back_to_chat: "Powrót do czatu",
  carousel_open: "Otwórz",
  carousel_close: "Zamknij",
  available: "Dostępne",
  expand_view: "Pełny widok",
  read_more: "Czytaj więcej",
  explore: "Odkryj",
  photo: "Zdjęcie",
  from_price: "od",
  rates: "Ceny",
  quote_group: {
    title: "Twoja wycena",
    total: "Razem",
    room: "Pokój {n}",
    other_options: "Inne opcje",
    rooms: "Pokoje: {n}",
    adult: "dorosły",
    adults: "dorosłych",
    child: "dziecko",
    children: "dzieci",
  },
  anchor_rooms: "Nasze propozycje",
  anchor_discover: "Warto odkryć",
  anchor_places: "Lokalizacja i okolica",
  anchor_videos: "Filmy",
  videos: "filmów",
  watch_video: "Zobacz film",
  feedback_useful: "Pomocna odpowiedź",
  feedback_not_useful: "Mało pomocna",
  proposal: "propozycja",
  proposals: "propozycji",
  contents: "treści",
  places: "miejsc",
  explore_title: "Państwa pobyt",
  explore_rooms: "Pokoje i ceny",
  explore_discover: "Warto odkryć",
  explore_videos: "Filmy",
  explore_places: "Miejsca",
  directions: "Jak dojechać",
  minimize_view: "Zmniejsz",

  // 1x6 P2-d-M · interactive concierge map (poi_map / itinerary templates).
  anchor_itinerary: "Twoja trasa",
  itinerary: "Trasa",
  stops: "przystanki",
  stop: "przystanek",
  walk_min: "min pieszo",
  itinerary_start: "Punkt startowy",
  your_hotel: "Twój hotel",
  explore_itineraries: "Trasy",
  map_loading: "Wczytywanie mapy…",
  cat_restaurant: "Jedzenie i napoje",
  cat_attraction: "Atrakcje",
  cat_beach: "Plaże",
  cat_essential: "Przydatne miejsca",
  cat_event: "Wydarzenia",
  cat_place: "Miejsce",
  reviews: "opinie",

  booking: {
    choose_rate: "Wybierz stawkę",
    your_details: "Twoje dane",
    review: "Podsumowanie",
    notes: "Uwagi lub prośby",
    notes_placeholder: "Alergie, godzina przyjazdu, łóżeczko…",
    privacy: "Przeczytałem/am i akceptuję politykę prywatności.",
    marketing: "Chcę otrzymywać oferty i nowości od hotelu.",
    privacy_required:
      "Do kontynuowania wymagana jest zgoda na przetwarzanie danych.",
    continue: "Dalej",
    back: "Wstecz",
    confirm: "Potwierdź rezerwację",
    submitting: "Chwileczkę…",
    cancel: "Anuluj",
    close: "Zamknij",
    retry: "Spróbuj ponownie",
    total: "Razem",
    cheapest: "Najtaniej",
    per_night: "za noc",
    no_payment_now: "Teraz bez płatności",
    nights: "nocy",
    guests: "gości",
    reference: "Numer",
    success_title: "Rezerwacja potwierdzona",
    success_body: "Potwierdzenie otrzymasz wkrótce e-mailem.",
    error_title: "Nie udało się",
    error_body:
      "Nie udało się dokończyć rezerwacji. Spróbuj ponownie za chwilę.",
    mock_notice: "Tryb testowy: nie utworzono prawdziwej rezerwacji.",
  },
};

export default pl;
